let PROTOCOL;
let API_ADDRESS;
let API_PORT;

if (process.env.NODE_ENV === "production") {
  API_ADDRESS = "swarm-story.herokuapp.com";
  API_PORT = "443";
  PROTOCOL = "https";
} else {
  API_ADDRESS = "192.168.1.106";
  API_PORT = "8000";
  PROTOCOL = "http";
}

export function getStoryEndpoint() {
  return `${PROTOCOL}://${API_ADDRESS}:${API_PORT}/api/story`;
}

export function getVoteEndpoint() {
  return `${PROTOCOL}://${API_ADDRESS}:${API_PORT}/api/vote`;
}

export function getVotingEndpoint(id = null) {
  if (id === null) {
    return `${PROTOCOL}://${API_ADDRESS}:${API_PORT}/api/voting`;
  } else {
    return `${PROTOCOL}://${API_ADDRESS}:${API_PORT}/api/voting/${id.toString()}`;
  }
}
